var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu-page"},[_c('div',{staticClass:"container"},[_c('menu-title',{attrs:{"title":"Inbox"},on:{"onCloseRequested":_vm.onCloseRequested}})],1),_c('conversation-list',{staticClass:"pt-2"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }